import { Nav } from "react-bootstrap";
import useUserStore from "../stores/User";

function AccountNav({setActiveTab}){
    const userData = useUserStore((state) => state.data);

    return (
        <Nav
            variant="underline"
            defaultActiveKey="favorites"
            className="mb-3"
            onSelect={(selectedKey) => setActiveTab(selectedKey || "")}
        >
            <Nav.Item>
                <Nav.Link eventKey="favorites">Favorites</Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link eventKey="downloads">Downloads</Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link eventKey="requests">Requests</Nav.Link>
            </Nav.Item>
            {userData && userData?.isIndexer && (
                <Nav.Item>
                    <Nav.Link eventKey="indexed">Indexed Files</Nav.Link>
                </Nav.Item>
            )}
        </Nav>
    );
}

export default AccountNav;